import { render, staticRenderFns } from "./SearchSorDialog.vue?vue&type=template&id=18725cd3"
import script from "./SearchSorDialog.vue?vue&type=script&lang=js"
export * from "./SearchSorDialog.vue?vue&type=script&lang=js"
import style0 from "./SearchSorDialog.vue?vue&type=style&index=0&id=18725cd3&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports